dayjs.locale('ja')

const app = new Vue({
  el: '#page',
  components: {
    Hooper: window.Hooper.Hooper,
    Slide: window.Hooper.Slide,
    HooperNavigation: window.Hooper.Navigation,
  },
  data: {
    mainVisualIndex: 0,
    mainVisuals: [],
    mainVisualSettings: {
      autoPlay: true,
      playSpeed: 3000,
      transition: 1000,
      centerMode: true,
      wheelControl: false,
      infiniteScroll: true,
    },
    seriesYears: [],
    sidebarSerieses: [],
    sidebarYear: '',
    recentMatches: [],
    hooperSettings: {
      autoPlay: true,
      trimWhiteSpace: true,
      playSpeed: 3000,
      transition: 500,
      wheelControl: false,
      infiniteScroll: true,
      centerMode: true,
      itemsToShow: 1.2,
      breakpoints: {
        680: { itemsToShow: 2 },
        1216: { itemsToShow: 3 },
      },
    },
  },
  filters: {
    kickoff(value) {
      return dayjs(value).format('YYYY.MM.DD (ddd) HH:mm')
    },
  },
  mounted() {
    if (this.$refs.frontPageMainvisuals) {
      this.mainVisuals = this.$refs.frontPageMainvisuals.dataset.images.split(',')
    }

    // 試合用サイドバーの処理
    if (this.$refs.matchSidebar) {
      const data = this.$refs.matchSidebar.dataset.years
      const { year, years } = JSON.parse(decodeURIComponent(data))
      this.seriesYears = years
      this.sidebarYear = year
      this.updateSidebarYear()
    }

    // 直近の試合カルーセルの処理
    if (this.$refs.recntMatchCarousel) {
      this.fetchRecentMatches()
    }
  },
  methods: {
    mainVisualBeforeSlide({ slideFrom }) {
      if (_.isNumber(slideFrom)) {
        this.mainVisualIndex = (slideFrom + 1) % this.mainVisuals.length
        return
      }
      this.mainVisualIndex = 0
    },
    isActiveYear(year) {
      return this.sidebarYear === year
    },
    updateSidebarYear() {
      axios
        .get(`/wp-json/custom/v1/series_by_year/${this.sidebarYear}`)
        .then((res) => {
          if (res.status !== 200) {
            return
          }
          const { year, serieses } = res.data
          this.sidebarSerieses = serieses
          this.sidebarYear = year
        })
    },
    onClickSidebarYear(year) {
      this.sidebarYear = year
      this.updateSidebarYear()
    },
    fetchRecentMatches() {
      axios
        .get('/wp-json/custom/v1/recent_matchies/10')
        .then((res) => {
          if (res.status !== 200) {
            return
          }
          this.recentMatches = res.data
        })
    }
  }
})
